import { ConnectionState } from 'livekit-client'
// Tailwind migration: component styles are applied via utility classes

interface ControlButtonsBarProps {
  // State
  connectionState: ConnectionState
  isMicMuted: boolean
  isCameraMuted: boolean
  
  // Actions
  toggleMicrophone: () => void
  toggleCamera: () => void
  onDeviceSettings: () => void
  onEndCall: () => void
}

export function ControlButtonsBar({
  connectionState,
  isMicMuted,
  isCameraMuted,
  toggleMicrophone,
  toggleCamera,
  onDeviceSettings,
  onEndCall,
}: ControlButtonsBarProps) {
  return (
    <div className="flex justify-center items-center gap-4 p-4 bg-black/80 border-t border-neutral-800">
      {/* Microphone toggle */}
      <button
        onClick={toggleMicrophone}
      className={`w-14 h-14 rounded-full border-0 text-white flex items-center justify-center text-[20px] transition-colors ${isMicMuted ? 'bg-red-500 hover:bg-red-600' : 'bg-neutral-700 hover:bg-neutral-600'} disabled:cursor-not-allowed disabled:opacity-50`}
        disabled={connectionState !== ConnectionState.Connected}
      >
        {isMicMuted ? '🔇' : '🎤'}
      </button>

      {/* Camera toggle */}
      <button
        onClick={toggleCamera}
  className={`w-14 h-14 rounded-full border-0 text-white flex items-center justify-center text-[20px] transition-colors ${isCameraMuted ? 'bg-red-500 hover:bg-red-600' : 'bg-neutral-700 hover:bg-neutral-600'} disabled:cursor-not-allowed disabled:opacity-50`}
        disabled={connectionState !== ConnectionState.Connected}
      >
        {isCameraMuted ? '📵' : '📹'}
      </button>

      {/* Device settings */}
      <button
        onClick={onDeviceSettings}
  className="w-14 h-14 rounded-full border-0 text-white flex items-center justify-center text-[20px] transition-colors bg-neutral-700 hover:bg-neutral-600"
      >
        ⚙️
      </button>

      {/* End call */}
      <button
        onClick={onEndCall}
  className="w-14 h-14 rounded-full border-0 text-white flex items-center justify-center text-[20px] transition-colors bg-red-500 hover:bg-red-600"
      >
        📞
      </button>
    </div>
  )
}
